import React from 'react';
import Header from './Header';
import Footer from './Footer';
import HowItWorks from './HowItWorks';
import AppPreview from './AppPreview';
import {IconArrowRight} from './Icons';
import {BOOK_URL} from '../siteConfig';

const you=[
  'Tell us how your business runs and what you want fixed',
  'Approve the plan and the messages we send on your behalf',
  'Reply to customers from one app, or let the automations do it',
  'Ask us whenever you want something changed'
];

const us=[
  'Set up every service and connect it to your phone, website and accounts',
  'Write the texts, emails and follow-ups, and test them with you',
  'Keep everything running, secure and up to date',
  'Make changes and answer questions when you need us'
];

function List({items}) {
  return <ul>{items.map((i)=> <li key={i}>{i}</li>)}</ul>;
}

function HowItWorksPage() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <section className="page-hero">
          <span className="kicker">How it works</span>
          <h1>You run the business. <em>We handle the tech.</em></h1>
          <p>A clear split of who does what, so nothing falls through the cracks and you never have to become the tech person.</p>
          <div className="hero-actions">
            <a className="primary-button" href={BOOK_URL}>Book a free call <IconArrowRight /></a>
            <a className="text-button" href="#/services">See all services</a>
          </div>
        </section>
        <section className="section" style={{paddingBottom: 40}}>
          <div className="center-heading">
            <span className="kicker">Who does what</span>
            <h2>Your part.<br /><em>Our part.</em></h2>
          </div>
          <div className="split">
            <div className="split-card"><h3>You</h3><List items={you} /></div>
            <div className="split-card dark"><h3>Us</h3><List items={us} /></div>
          </div>
        </section>
        <HowItWorks />
        <AppPreview />
      </main>
      <Footer />
    </div>
  );
}

export default HowItWorksPage;
